import { apiClient } from '@/lib/api-client';
import type { SavedFilter, SavedFilterPage } from '@bbpos/types';

/** Saved filters — Odoo favourites on the list pages (T27), kept on the server per user. */
export const savedFiltersService = {
  /** Your own filters for the page, then the ones the team shared. */
  list(page: SavedFilterPage) {
    return apiClient<SavedFilter[]>(`/saved-filters?page=${encodeURIComponent(page)}`);
  },
  /** A name you already used on the page is overwritten. */
  create(input: {
    page: SavedFilterPage;
    name: string;
    filters: Record<string, string>;
    is_shared?: boolean;
    is_default?: boolean;
  }) {
    return apiClient<SavedFilter>('/saved-filters', { method: 'POST', body: input });
  },
  update(id: string, input: { is_shared?: boolean; is_default?: boolean }) {
    return apiClient<SavedFilter>(`/saved-filters/${id}`, { method: 'PATCH', body: input });
  },
  remove(id: string) {
    return apiClient<{ id: string }>(`/saved-filters/${id}`, { method: 'DELETE' });
  },
};
